import React from 'react';
import { Router } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import { DesignSystemProvider } from '@shiftfinancial/design-system';
import Main from './Components/pages/main/Container';
import themeSelector from './theme/themeSelector';
import { pageTransfer } from './utils/history';

const theme = themeSelector.select();

const App = () => (
  <DesignSystemProvider>
    <ThemeProvider theme={theme.theme}>
      <CssBaseline />
      <Router history={pageTransfer}>
        <Main headerLogo={theme.headerLogo} />
      </Router>
    </ThemeProvider>
  </DesignSystemProvider>
);

export default App;
